<template>
  <div :data-id="layerItem['id']" class="layer-item">
    <template v-if="layerItem.group && !layerItem['hidden']">
      <span class="sortable-handler"><icon name="arrows-alt" scale="1" class="dragHandle"></icon></span>
      <a v-b-toggle="'layerManager'+layerItem.group.id" variant="primary" :accordion="'layerManagerAccordion'+layerItem.group.id">
        <label>{{layerItem.name || 'No group'}}</label>
      </a>
      <b-collapse :id="'layerManager'+layerItem.group.id" :visible="layerItem.group.expanded" :accordion="'layerManagerAccordion'+layerItem.group.id" class="mt-1">
        <b-card no-body>
          <template v-for="child in layerItem.children">
            <layer-control-item v-if="!child['hidden']" :layerItem="child" :key="'layer'+child['id']"></layer-control-item>
          </template>
        </b-card>
      </b-collapse>
    </template>
    <template v-else>
      <b-container class="layerManager-second" size="sm">
        <div class="layerManagerLeftControls">
          <!-- <icon name="arrows-alt" scale=".8" class="dragHandle sortable-handler"></icon> -->
          <b-form-checkbox  :disabled="layerItem.loading" @change="itemChange"
                            :checked="layerItem.checked" size="small" class="mb-sm-0 form-check-xs"></b-form-checkbox>

          <label>{{layerItem.title || layerItem.name}}</label>
          <!-- <em class="layer-type">{{getLayerTypeName()}}</em> -->
          <div class="layer-spinner" v-if='layerItem.loading'>
            <icon name="spinner" pulse/>
          </div>
        </div>
        <div class="layerManagerLeftControls">
          <b-nav>
            <b-nav-item-dropdown class="dropdown-xs">
              <b-dropdown-item @click="toggleLegend">Toggle Legend</b-dropdown-item>
              <b-dropdown-item @click="zoomTo">Zoom to</b-dropdown-item>
              <template v-if="layerItem.temporal_field">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  @click="addTemporalLayer">Temporal scale</b-dropdown-item>
              </template>

              <template v-if="layerItem.data_type === 'wfs'">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="showLabels">Labels</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  @click="addAtLayer">Features</b-dropdown-item>
              </template>

              <template v-if="renderedLabelsMap && renderedLabelsMap.length > 0">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="clearLabels" >Clear Labels</b-dropdown-item>
              </template>

              <template v-if="layerItem.data_type === 'wfs' || layerItem.data_type === 'wms'">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  @click="reloadLayer">
                  Reload
                </b-dropdown-item>
              </template>
              <template v-if="layerItem.temporal_field" >
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addTemporalLayer">Temporal scale</b-dropdown-item>
              </template>
              <template v-if="filterConf.length">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item  @click="showFilters">
                  Filters
                </b-dropdown-item>
                <template v-if="$store.getters['map/layerFiltersMap'][layerItem['id']]">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item  @click="clearFilters">
                    Clear filters
                  </b-dropdown-item>
                </template>
              </template>

            </b-nav-item-dropdown>
          </b-nav>
        </div>
      </b-container>
    </template>

  </div>
</template>
<script>
  import 'vue-awesome/icons/list'
  import 'vue-awesome/icons/arrows-alt'
  import Sortable from 'sortablejs'
  import LabelModel from './LabelModel'
  import AttributeTable from './AttributeTable.vue'
  import LayerFilters from './LayerFilters.vue'

  export default {
    components: {LayerFilters},
    name: 'layer-control-item',
    props: {
      layerItem: {
        default: null
      }
    },
    data () {
      return {
        filtersShown: false
      }
    },
    computed: {
      filterConf () {
        return this.layerItem['filters'] ? JSON.parse(this.layerItem['filters']) : []
      },
      renderedLabelsMap () {
        return this.$store.getters['map/renderedLabelsMap'][this.layerItem['id']]
      }
    },
    methods: {
      getLayerTypeName () {
        let name = ''
        if (this.layerItem.data_type === 'wms') {
          name = 'tiles'
        }

        if (this.layerItem.data_type === 'wfs') {
          name = 'vector'
        }

        if (this.layerItem.data_type === 'base') {
          name = 'base'
        }
        return name
      },
      itemChange (val) {


        //tmp
        /*if (this.$store.getters['project/currentProject'].workpack.id === 12040 && (this.layerItem.name.indexOf('.tif') > -1)) {
          let tree = this.$store.getters['map/layersTree']
          let enabledSeams = []
          let lateraLayer = []
          this.$mapService.walkTree(tree, l => {
            if (l.name === this.layerItem.name) {
              return
            }
            if (l.checked && l.name.indexOf('_floor_') > -1) {
              enabledSeams.push(l.name.split(":")[1]);
            }

            if (l.name.indexOf('well_drillstring') > -1 && l['data_type'] === 'wms') {
              lateraLayer = l
            }
          })

          if (lateraLayer) {
            if (val) {
              enabledSeams.push(this.layerItem.name.split(":")[1])
            }
            if (enabledSeams.length > 0) {
              lateraLayer['cql_custom'] = `workpack_id=6 AND seam_ident IN (${enabledSeams.map(s => "'"+s+"'").join(',')})`
            } else {
              lateraLayer['cql_custom'] = `workpack_id=6`
            }

            this.$mapService.forceCreateLayer(lateraLayer)
          }

        }*/

        if (this.$store.getters['map/permaLayers']) {
          this.$store.commit('map/permaLayers', [])
        }

        this.layerItem['checked'] = val

        // store in browser
        localStorage.setItem('layer_tool_' +this.$store.getters['project/currentProject'].workpack.id + '_' + this.layerItem['name'] , val)

        this.$store.dispatch('map/layerState', this.layerItem)
      },
      zoomTo () {
        this.$mapService.zoomToLayer(this.layerItem)
      },
      toggleLegend () {
        this.$mapService.toggleLayerLegend(this.layerItem)
      },
      addTemporalLayer () {
        this.$store.commit('map/addTemporalLayer', this.layerItem)
        this.$store.getters['cmp/all']['tmp_scale']['enabled'] = true
      },
      showLabels () {
        let opts = {
          available: true,
          enabled: true,
          clazz: LabelModel,
          w: 4,
          h: 6,
          x: 3,
          y: 0,
          propsData: {
            layer: this.layerItem
          },
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: this.layerItem['id']+'labels',
          payload: opts
        })

      },
      addAtLayer () {
        let opts = {
          available: true,
          enabled: true,
          clazz: AttributeTable,
          w: 9,
          h: 6,
          x: 3,
          y: 0,
          propsData: {
            layer: this.layerItem
          },
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: this.layerItem['id']+'attributes',
          payload: opts
        })
      },
      showFilters () {
        let opts = {
          available: true,
          enabled: true,
          clazz: LayerFilters,
          w: 4,
          h: 3,
          x: 3,
          y: 0,
          propsData: {
            layerKegsId: this.layerItem.id,
            filterConf: this.filterConf,
          },
          destroyable: true
        }

        this.$store.commit('cmp/update', {
          cmp: this.layerItem['id']+'filters',
          payload: opts
        })

        this.$store.commit('map/setLayerFilter', [this.layerItem['id'], true])
      },
      clearFilters () {
        let layer = {...this.layerItem}
        layer['cql_custom'] = null
        this.$mapService.forceCreateLayer(layer)
        this.$store.commit('map/setLayerFilter', [this.layerItem['id'], false])
      },
      reloadLayer () {
        this.$mapService.forceCreateLayer(this.layerItem)
      },
      clearLabels () {
        this.$mapService.setLayerLabel(this.layerItem, null)
        this.$store.commit('map/setLayerLabel', [this.layerItem['name'], false])
      }
    }
  }
</script>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/components/map/layers/LayerControlItem.vue